export const geoGroups: {label: string, value: string[]}[] = [
  {
    label: 'FR/BE/MC/DOM-TOM',
    value: ['BE', 'BL', 'FR', 'GF', 'GP', 'MC', 'MQ', 'NC', 'PF', 'PM', 'RE', 'TF', 'WF', 'YT']
  },
  {
    label: 'US/CA',
    value: ['CA', 'US']
  },
  {
    label: 'UK/IR/IS',
    value: ['GB', 'IE', 'IS']
  },
  {
    label: 'AU/NZ',
    value: ['AU', 'NZ']
  },
  {
    label: 'ZA',
    value: ['ZA']
  },
  {
    label: 'ES',
    value: ['ES']
  },
  {
    label: 'LATAM',
    value: ['AR', 'BO', 'CL', 'CO', 'CR', 'CU', 'DM', 'DO', 'EC', 'GT', 'GY', 'HN', 'HT', 'JM', 'MX', 'NI', 'PA', 'PE', 'PR', 'PY', 'SV', 'UY', 'VE']
  },
  {
    label: 'DE/AT',
    value: ['DE', 'AT']
  },
  {
    label: 'NO/SE/FI/DK',
    value: ['DK', 'FI', 'NO', 'SE']
  },
  {
    label: 'EASTERN EUROPE/BALCANS',
    value: ['AL', 'BA', 'BG', 'BY', 'CZ', 'EE', 'GE', 'HR', 'HU', 'LT', 'LV', 'MD', 'ME', 'MK', 'PL', 'RO', 'RS', 'RU', 'SI', 'SK', 'UA']
  },
  {
    label: 'AFRICA (EN)',
    value: ['BW', 'EH', 'ET', 'GH', 'GM', 'KE', 'LB', 'LR', 'LS', 'LY', 'MR', 'MW', 'MZ', 'NA', 'NG', 'SD', 'SL', 'SO', 'SS', 'SZ', 'TZ', 'UG', 'YE', 'ZM', 'ZW']
  },
  {
    label: 'AFRICA (FR)',
    value: ['BF', 'BI', 'BJ', 'CD', 'CF', 'CG', 'CI', 'CM', 'DJ', 'GA', 'GN', 'KM', 'MG', 'ML', 'NE', 'RW', 'SC', 'SN', 'TD', 'TG']
  },
  {
    label: 'ASIA (EN)',
    value: ['AE', 'BD', 'CN', 'ID', 'JP', 'KH', 'KP', 'KR', 'LA', 'MN', 'MY', 'PH', 'PK', 'SG', 'TH', 'TR', 'TW', 'VN']
  },
  {
    label: 'IN',
    value: ['IN']
  },
  {
    label: 'PT',
    value: ['PT']
  },
  {
    label: 'BR',
    value: ['BR']
  }
];
